import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PaisesComponent} from '../paises.component'
//Services
import {CountryService} from 'src/app/core/services/parameters/country.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'edit-modal',
  templateUrl: './edit-modal.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditarPaisModal implements OnInit {

  editCountryForm: FormGroup;
  loading = false;
  showAlert = false;
  countryId;
  countryData = {
    id: '',
    createdAt: '',
    countryCod: ''
  };

  constructor(
    public dialogRef: MatDialogRef<PaisesComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private countryService: CountryService
  ) {
  }

  ngOnInit(): void {
    this.editCountryForm = this.fb.group({
      country: [, Validators.required],
      countryCod: [,Validators.required]
    })
    this.countryId = this.data.id;
    this.countryService.getCountryById(this.countryId).subscribe(_res => {
      this.countryData = _res;
      this.editCountryForm.patchValue({
        country: _res.name,
        countryCod: _res.code
      })
    });
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.editCountryForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editCountryForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.country,
        code: form.value.countryCod
      }
      this.countryService.updateCountry(this.countryId, data).subscribe(_res => {
        this.alert.setNotice('Pais actualizado correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo actualizar el pais', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
